/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type { SignedUrl } from '../models/index';
import { SignedUrlFromJSON, SignedUrlToJSON } from '../models/index';

/**
 *
 */
export class FilesApi extends runtime.BaseAPI {
    /**
     * Request a signed bucket url
     * Get Upload Url
     */
    async getUploadUrlApiV1FilesSignedUrlGetRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<SignedUrl>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters['Authorization'] = await this.configuration.accessToken(
                'LoginManager',
                [],
            );
        }

        const response = await this.request(
            {
                path: `/api/v1/files/signed-url`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) => SignedUrlFromJSON(jsonValue));
    }

    /**
     * Request a signed bucket url
     * Get Upload Url
     */
    async getUploadUrlApiV1FilesSignedUrlGet(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<SignedUrl> {
        const response = await this.getUploadUrlApiV1FilesSignedUrlGetRaw(initOverrides);
        return await response.value();
    }
}
